import { render, staticRenderFns } from "./MagazineEdit.vue?vue&type=template&id=3d10cfd2&"
import script from "./MagazineEdit.vue?vue&type=script&lang=js&"
export * from "./MagazineEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports